export enum Languages {
  EN = 'en',
  NL = 'nl',
  FR = 'fr',
}

export const LOCAL_STORAGE_LANG = 'lang';
export const LOCAL_STORAGE_LANG_CHANGED = 'langChanged';
